import React from 'react';

import { useQuery } from '@tanstack/react-query';

import InsurancesTable from '../../../Insurance/InsurancesTable';
import AddOrEditPageTabs from '../../../AddOrEditPageTabs';

import LoanService from '../../../../../services/LoanService';
import { useServicerStore } from '../../../../../store';

const tabs = [
  {
    label: 'Insurances',
  },
  {
    label: 'Claims',
  },
];

export default function Insurances({ loanId, isFetching, readOnly }) {
  const userRole = useServicerStore((state) => state.userRole);
  const isSuperAdmin = userRole === 'superAdmin';
  const isLender = userRole === 'lender';

  const { data: insurances, refetch } = useQuery({
    queryKey: ['insurances', loanId],
    queryFn: () => LoanService.getLoanInsurances(loanId),
    enabled: !!loanId,
  });

  const createInsuranceLink = (row) =>
    `/loans/${loanId}/insurances/${row.id}?tab=Insurance`;

  return (
    <div>
      {isSuperAdmin || isLender ? (
        <div className="mb-4 flex justify-between md:items-center flex-col md:flex-row gap-2 h-[37px]">
          <AddOrEditPageTabs tabs={tabs} />
        </div>
      ) : null}
      <InsurancesTable
        refetch={refetch}
        loanId={loanId}
        isFetching={isFetching}
        insurances={insurances}
        createInsuranceLink={createInsuranceLink}
        readOnly={readOnly}
      />
    </div>
  );
}
